var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1875 13.3V9.5C25.1875 4.18 20.925 0 15.5 0C10.075 0 5.8125 4.18 5.8125 9.5V13.3C2.51875 13.3 0 15.77 0 19V32.3C0 35.53 2.51875 38 5.8125 38H25.1875C28.4813 38 31 35.53 31 32.3V19C31 15.77 28.4813 13.3 25.1875 13.3ZM9.6875 9.5C9.6875 6.27 12.2062 3.8 15.5 3.8C18.7938 3.8 21.3125 6.27 21.3125 9.5V13.3H9.6875V9.5ZM17.4375 28.5C17.4375 29.64 16.6625 30.4 15.5 30.4C14.3375 30.4 13.5625 29.64 13.5625 28.5V22.8C13.5625 21.66 14.3375 20.9 15.5 20.9C16.6625 20.9 17.4375 21.66 17.4375 22.8V28.5Z",
    fill: "#B5B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d182a5a891b656838d47ceb58d096bb8.svg";
export { ForwardRef as ReactComponent };